import Switch from '@components/v2/form/Switch/Switch';
import LangEnum from '../../../../../../lang/LangEnum';
import { useTranslation } from '../../../../../translation/TranslationContext';
import { RelatedProductsSectionGeneralSettingsProps } from '../../../types/GeneralSettings.types';

interface RelatedProductsSectionSwitchProps extends RelatedProductsSectionGeneralSettingsProps {}

const RelatedProductsSectionSwitch = ({
  handleChangeAndBlur,
  generalSettings,
}: RelatedProductsSectionSwitchProps) => {
  const { translate } = useTranslation();

  return (
    <Switch
      label={translate(LangEnum.RELATED_PRODUCTS_GENERAL_SETTINGS_SECTION_SWITCH_DESCRIPTION)}
      name="enableRelatedProductsFilterInProductDetails"
      size="medium"
      checked={generalSettings.enableRelatedProductsFilterInProductDetails}
      onChange={(_, checked) =>
        handleChangeAndBlur({
          value: checked,
          name: 'enableRelatedProductsFilterInProductDetails',
        })
      }
    />
  );
};

export default RelatedProductsSectionSwitch;
